// utils/activityLogger.js
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../firebase';

/**
 * Logs an activity event to Firestore
 * @param {string} eventType - Type of event (e.g., 'record_start', 'rerecord', 'copy_link', 'view')
 * @param {Object} data - Additional data about the event
 * @returns {Promise<void>}
 */
export const logActivity = async (eventType, data = {}) => {
  try {
    const user = auth.currentUser;
    
    const eventData = {
      eventType,
      userId: user ? user.uid : (data.userId || 'anonymous'),
      timestamp: serverTimestamp(),
      ...data
    };

    const eventsRef = collection(db, 'video_events');
    await addDoc(eventsRef, eventData);
    
    return true;
  } catch (error) {
    console.error(`Error logging ${eventType}:`, error);
    return false;
  }
};

/**
 * Specifically logs a video view from a visitor
 * @param {string} videoId - The ID of the video being viewed
 * @param {string} creatorId - The ID of the user who created the video
 */
export const logVideoView = async (videoId, creatorId) => {
  return logActivity('view', { 
    videoId, 
    creatorId,
    userAgent: navigator.userAgent,
    referrer: document.referrer || 'direct'
  });
};

/**
 * Logs when a user starts a recording session
 */
export const logRecordStart = async () => {
  return logActivity('record_start');
};

/**
 * Logs when a user clicks "Record Again"
 */
export const logRerecord = async () => {
  return logActivity('rerecord');
};

/**
 * Logs when a user copies a share link
 * @param {string} videoId 
 * @param {string} copyType - 'link' or 'email'
 */
export const logShareAction = async (videoId, copyType) => {
  return logActivity('share', { videoId, copyType });
};
